(() => {
  // Shopify's theme editor needs to own navigation and section reloads.
  // Disable our storefront-only AJAX navigation while editing.
  if (window.Shopify && window.Shopify.designMode) return;

  if (window.__kingdomPersistentNavigation) return;
  window.__kingdomPersistentNavigation = true;

  const MAIN = '#MainContent';
  let navigating = false;

  const sameStoreUrl = (url) => {
    try {
      const u = new URL(url, location.href);
      if (u.origin !== location.origin) return null;
      if (u.protocol !== 'http:' && u.protocol !== 'https:') return null;
      return u;
    } catch (_) { return null; }
  };

  const shouldHardNavigate = (u) => {
    const p = u.pathname;
    return p.startsWith('/checkout') || p.startsWith('/checkouts') ||
      p.startsWith('/account') || p.startsWith('/challenge') ||
      p.startsWith('/payments') || p.startsWith('/apps/');
  };

  const runScripts = (root) => {
    const scripts = [...root.querySelectorAll('script')];
    for (const oldScript of scripts) {
      const script = document.createElement('script');
      for (const attr of oldScript.attributes) script.setAttribute(attr.name, attr.value);
      script.textContent = oldScript.textContent;
      oldScript.replaceWith(script);
    }
  };

  const navigate = async (href, { replace = false, scroll = true } = {}) => {
    const u = sameStoreUrl(href);
    if (!u || shouldHardNavigate(u)) {
      location.href = href;
      return;
    }
    if (navigating) return;
    if (u.href === location.href) return;

    navigating = true;
    document.documentElement.dataset.krNavigating = 'true';
    try {
      const response = await fetch(u.href, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'KingdomPersistentNavigation' }
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const incoming = doc.querySelector(MAIN);
      const current = document.querySelector(MAIN);
      if (!incoming || !current) throw new Error('Main content not found');

      // IMPORTANT: only MainContent is replaced. The global Kingdom Radio player
      // lives outside MainContent, so the original audio element remains alive.
      current.replaceChildren(...[...incoming.childNodes].map((node) => document.importNode(node, true)));
      for (const attr of [...current.attributes]) {
        if (!incoming.hasAttribute(attr.name)) current.removeAttribute(attr.name);
      }
      for (const attr of [...incoming.attributes]) current.setAttribute(attr.name, attr.value);

      document.title = doc.title;
      if (replace) history.replaceState({ kingdomNav: true }, '', u.href);
      else history.pushState({ kingdomNav: true }, '', u.href);

      runScripts(current);
      document.dispatchEvent(new CustomEvent('kingdom:navigation-complete', { detail: { url: u.href } }));
      if (scroll) window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch (error) {
      console.warn('[Kingdom navigation] Falling back to normal navigation:', error);
      location.href = u.href;
    } finally {
      navigating = false;
      delete document.documentElement.dataset.krNavigating;
    }
  };

  window.KingdomNavigate = (href) => navigate(href);

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const a = event.target.closest?.('a[href]');
  if (
    !a ||
    a.hasAttribute('download') ||
    (a.target && a.target.toLowerCase() !== '_self')
  ) return;
    const href = a.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;
    const u = sameStoreUrl(a.href);
    if (!u || shouldHardNavigate(u)) return;
    event.preventDefault();
    navigate(u.href);
  }, true);

  window.addEventListener('popstate', () => navigate(location.href, { replace: true, scroll: false }));
})();
